export default __webpack_public_path__ + "static/media/green.bd3cb1d7.png";